export const changeRankedCropNameReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_RankedCropName":
      return action.payload.rankedCropName;
    default:
      return state;
  }
};
